( () => {
	const siteName = 'default-package_2023_vanilla';
	const htmlHasClass = ( _class ) => { return document.documentElement.classList.contains( _class ); };
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			isMobile: htmlHasClass( 'ua-mobile' ),
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: window.innerWidth,
				height: window.innerHeight
			},
			header: {
				desktop: 110,
				sp: 60
			}
		},
		localDecision() {
			const regExp = new RegExp( `(test\\.${siteName}\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.)`, 'g' );
			return regExp.test( location.hostname );
		},
		localLoading() { // ローカル環境ならincludeをAjaxで読み込む
			const _this = this;
			const key = 'inc_';
			let ajaxArray = [];
			let ajaxArrayList = [];
			let includeClass = document.querySelectorAll( `[class*="${key}"]` );

			includeClass.forEach( ele => {
				let path = ele.innerHTML.split( ' ' )[1];
				ajaxArray.push( path );
			} );

			if ( ajaxArray.length ) {
				ajaxArray.forEach( ele => {
					let xhr = new XMLHttpRequest();
					let promise = new Promise( ( resolve, reject ) => {
						xhr.onreadystatechange = function () {
							if ( xhr.readyState === 4 ) {
								if ( xhr.status === 200 ) {
									resolve( xhr.responseText );
								} else {
									reject( xhr.statusText );
								}
							}
						};
					} );
					xhr.open( 'GET', ele + '.html', true );
					xhr.send();
					ajaxArrayList.push( promise );
				} );

				Promise.all( ajaxArrayList ).then( results => {
					let regExp = new RegExp( key );

					results.forEach( ele => {
						let classList = ele.split( / |\"/g );
						let position;

						classList.forEach( ele2 => {
							if ( ele2.match( regExp ) ) { position = ele2; }
						} );
						document.querySelectorAll( '.' + position ).forEach( ele2 => {
							ele2.outerHTML = ele;
						} );
						console.log( 'Succeeded to read the include file!:', position );
					} );

					_this.loadDelayScript();
				} ).catch( ( error ) => {
					console.error( 'Failed to read the include file:', error );
					_this.loadDelayScript();
				} );
			} else {
				_this.loadDelayScript();
			}
		},
		getQuery() {
			let vars = [];
			let hash = null;
			let hashes = window.location.href.slice( window.location.href.indexOf( '?' ) + 1 ).split( '&' );
			hashes.forEach( ele => {
				hash = ele.split( '=' );
				hash[1] = ( hash[1].indexOf( '#' ) !== -1 ) ? hash[1].split( '#' )[0] : hash[1];
				vars.push( hash[0] );
				vars[hash[0]] = hash[1];
			} );
			return vars;
		},
		nextToggle() {
			const switchElements = document.querySelectorAll( '.js-toggle' );

			switchElements.forEach( switchElement => {
				switchElement.addEventListener( 'click', e => {
					e.currentTarget.classList.toggle( a );

					const toggleBlock = e.currentTarget.nextElementSibling;
					toggleBlock.classList.toggle( a );
					if ( toggleBlock.style.height ) {
						toggleBlock.style.height = null;
					} else {
						toggleBlock.style.height = toggleBlock.scrollHeight + 'px';
					}
				} );

				const toggleBlock = switchElement.nextElementSibling;
				const close = toggleBlock.querySelector('.js-toggle-close');
				if (close) {
					close.addEventListener('click', e => {
						switchElement.classList.remove( a );
						toggleBlock.classList.remove( a );
						if ( toggleBlock.style.height ) {
							toggleBlock.style.height = null;
						} else {
							toggleBlock.style.height = toggleBlock.scrollHeight + 'px';
						}
					})
				}

			} );
		},
		tabSwitch() {
			let $tab = document.querySelectorAll( '.js-tab' );
			let $content = document.querySelectorAll( '.js-tab-content' );
			if ( $tab.length ) {
				// ハッシュタグで絞り込み
				if ( location.hash ) {
					let hash = location.hash.split( '#' )[1];
					$tab.forEach( ele => {
						ele.classList.remove( a );
						if ( ele.getAttribute( 'data-target' ).match( hash ) ) {
							ele.classList.remove( a );
						}
					} );
					$content.forEach( ele => {
						ele.classList.remove( a );
						ele.classList.remove( v );
						if ( ele.getAttribute( 'data-target' ).match( hash ) ) {
							$( ele ).addClass( a );
							setTimeout( () => { ele.classList.add( v ); }, 200 );
						}
					} );
				}

				$tab.forEach( ele => {
					ele.addEventListener( 'click', () => {
						$tab.forEach( ele2 => { ele2.classList.remove( a ); } )
						ele.classList.add( a );
						$content.forEach( ele => {
							ele.classList.remove( a );
							ele.classList.remove( v );
						} );

						let $target;
						let target = ele.getAttribute( 'data-target' );
						if ( target === 'all' ) {
							$target = $content;
						} else {
							$target = document.querySelectorAll( '[data-target="' + target + '"]' );
						}
						$target.forEach( ele => {
							ele.classList.add( a );
							setTimeout( () => { ele.classList.add( v ); }, 200 );
						} );
					} );
				} );
			}
		},
		easeScroll() {
			const scrollToObject = ( _self ) => {
				let hash = _self.currentTarget.href.split( '#' )[1];
				let pos = hash === 'pagetop' ? 0 : document.getElementById( hash ).getBoundingClientRect().top;
				let offset = hash === 'pagetop' ? 0 : window.scrollY;
				pos += offset;

				if ( hash !== 'pagetop' ) {
					if ( FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp ) {
						pos = pos - FUNCTIONS.va.header.sp;
					} else {
						pos = pos - FUNCTIONS.va.header.desktop;
					}
				}
				window.scrollTo( { top: pos, behavior: 'smooth' } );
			}
			document.querySelectorAll( 'a[rel="scroll"]' ).forEach( ( ele ) => {
				ele.addEventListener( 'click', ( e ) => {
					e.preventDefault();
					if ( /#/.test( e.currentTarget.href ) ) {
						scrollToObject( e );
						return false;
					}
				} );
			} );
		},
		easeScrollHash() {
			const hash = location.hash;
			if (hash) {
				// フォーカス用関数
				// const scrollFocus = (_hash) => {
				// 	let hash = _hash;
				// 	if (hash !== 'pagetop') {
				// 		const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
				// 		const focusableElements = Array.from(
				// 			document.getElementById(hash).querySelectorAll(focusableElementsSelector)
				// 		);
				// 		if(focusableElements.length) {
				// 			focusableElements[0].focus();
				// 		}
				// 	}
				// }

				// スクロール完了後に実行する関数
				let scrollResolveTimeout;
				const waitForScrollComplete = (_hash) => {
					return new Promise((resolve) => {
						const scrollTimeout = setTimeout(() => {
						resolve(true);
						}, 100);
						const scrollTimeoutEvent = addEventListener('scroll', function fn (e) {
							clearTimeout(scrollTimeout);
							clearTimeout(scrollResolveTimeout);
							scrollResolveTimeout = setTimeout(function () {
								// scrollFocus(_hash);
								FUNCTIONS.matchHeight();
								removeEventListener('scroll', fn);
								resolve(true);
							}, 100);
						});
					});
				}
				window.addEventListener('load', async () => {

					document.documentElement.style.display = 'none';
					document.body.style.display = 'none';

					setTimeout(() => {
						document.documentElement.style.display = 'block';
						document.body.style.display = 'block';

						let pos = document.getElementById(hash.split('#')[1]).getBoundingClientRect().top;

						if(!(location.pathname.split('/')[1] == 'history')) {
							if (hash !== 'pagetop') {
								if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
									pos = pos - FUNCTIONS.va.header.sp;
								} else {
									pos = pos - FUNCTIONS.va.header.desktop;
								}
							}
						} else {
							if (hash !== 'pagetop') {
								if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
									pos = pos - (FUNCTIONS.va.header.sp + 70);;
								} else {
									pos = pos - (FUNCTIONS.va.header.desktop + 90);;
								}
							}
						}
						window.scrollTo({ top: pos, behavior: 'smooth' });
					}, 100);
					await waitForScrollComplete(hash);
				});
			}
		},
		pageTop() {
			let footer = document.querySelector( '.footer' );
			let $pagetop = document.querySelector( '.footer-pagetop' );

			if ( $pagetop ) {
				window.addEventListener( 'scroll', ( e ) => {
					if ( window.scrollY > '100' ) {
						$pagetop.classList.add( v );
					} else {
						$pagetop.classList.remove( v );
					}
				} );
			}
		},
		setImgAttrWidthHeight() {
			const getImg = ( _src ) => {
				return new Promise( ( resolve, reject ) => {
					const image = new Image();
					image.src = _src;
					image.onload = () => { resolve( image ); }
					image.onerror = ( error ) => { reject( error ); }
				} );
			};

			const imgs = document.getElementsByTagName( 'img' );

			for ( const img of imgs ) {
				const src = img.getAttribute( 'src' );
				getImg( src ).then( ( res ) => {
					if ( !img.hasAttribute( 'width' ) ) {
						img.setAttribute( 'width', res.width );
					}
					if ( !img.hasAttribute( 'height' ) ) {
						img.setAttribute( 'height', res.height );
					}
				} )
					.catch( ( error ) => { console.log( error ); } );
			}
		},
		setModal() {
			const createModal = ( _appendHTML ) => {
				const $container = document.createElement( 'div' );
				$container.className = 'mod-modal-overlay';
				$container.innerHTML = _appendHTML;
				document.body.appendChild( $container );

				$container.classList.add( a );
				setTimeout( () => {
					$container.classList.add( v );
					document.querySelectorAll( '.mod-modal-closeArea, .mod-modal-closeBtn, .mod-modalContent a' ).forEach( ( ele ) => {
						ele.addEventListener( 'click', ( e ) => {
							$container.classList.remove( v );
							setTimeout( () => {
								$container.classList.remove( a );
								$container.remove();
							}, 400 );
						} );
					} );
				} );
			};

			document.querySelectorAll( '.mod-modal' ).forEach( ( ele ) => {
				ele.addEventListener( 'click', ( e ) => {
					let targetKey = e.currentTarget.getAttribute( 'data-target' );
					console.log(targetKey);
					let $content = document.querySelector( `.mod-modalContent[data-target="${targetKey}"]` );
					console.log($content);
					if ( $content.outerHTML ) {
						let appendHTML = `<div class="mod-modal-closeArea"></div>
							<span class="mod-modal-closeBtn"><span></span></span>
							${$content.outerHTML}`;
						createModal( appendHTML );
					}
					return false;
				} );
			} );

			// 画像1個だけのモーダル
			document.querySelectorAll( '.mod-modalImg' ).forEach( ( ele ) => {
				ele.addEventListener( 'click', ( e ) => {
					let appendHTML = `<div class="mod-modal-closeArea"></div>
						<span class="mod-modal-closeBtn"><span class="mod-modal-closeBtn"><span></span></span></span>
						${e.currentTarget.querySelector( 'img' ).outerHTML}`;
					createModal( appendHTML );
				} );
			} );
		},
		matchHeight() {
			console.log("matchHeight");
			const $elements = document.querySelectorAll( '[data-mh]' );
			const groups = new Map();

			$elements.forEach( ele => { ele.style.height = 'auto'; } ); // 初期化

			$elements.forEach( ele => {
				const attributeName = ele.getAttribute( 'data-mh' );
				if ( !groups.has( attributeName ) ) {
					groups.set( attributeName, [] );
				}
				groups.get( attributeName ).push( ele );
			} );
			groups.forEach( group => {
				const attributeGroups = new Map();
				group.forEach( ele => {
					const attributeName = ele.getAttribute( 'data-mh' );
					const topPosition = ele.getBoundingClientRect().top;
					const key = attributeName + '_' + topPosition;
					if ( !attributeGroups.has( key ) ) {
						attributeGroups.set( key, [] );
					}
					attributeGroups.get( key ).push( ele );
				} );
				attributeGroups.forEach( (item) => {
					const maxHeight = Math.max( ...item.map( ele => ele.offsetHeight ) );
					item.forEach( (ele2) => {
						ele2.style.height = `${maxHeight}px`;
					});
				});
			} );
		},
		inViewAnimation() {
			const target = document.querySelectorAll( '.js-fade' );
			const options = {
				root: null,
				rootMargin: '-30% 0px',
				threshold: 0
			};
			const callback = ( entries, observer ) => {
				entries.forEach( entry => {
					if ( entry.isIntersecting ) {
						entry.target.classList.add( v );
					}
				} );
			};
			const observer = new IntersectionObserver( callback, options );

			target.forEach( ele => {
				observer.observe( ele );
			} );
		},
		headerCurrent() {
			const linkAreaList = document.querySelectorAll(".header-navi-bottom-link-item-mega-layer02")
			linkAreaList.forEach(linkArea => {
				linkArea.querySelectorAll('a').forEach(link => {
					const aTagPath = link.pathname
					const currentPath = location.pathname.replace('index.html', '')
					if (currentPath === aTagPath) {
						link.classList.add(a);

						const hotTopics = document.getElementsByClassName("js-hotTopics")[0]
						if (hotTopics.getElementsByClassName("is-active").length) {
							hotTopics.classList.add(a);
						}
					}
				})
			})

			const item = document.querySelectorAll('.header-navi-bottom-link-item')
			item.forEach(ele => {
				const aTagPath = ele.children[0].pathname
				const currentPath = location.pathname.replace('index.html', '')
				if (currentPath.indexOf(aTagPath) != -1) {
					ele.classList.add(a);
				}
			});
		},
		footerCurrent() {
			const linkArea = document.getElementsByClassName("footer-link")[0]
			const item = linkArea.querySelectorAll('a')
			item.forEach(ele => {
				const aTagPath = ele.pathname
				const currentPath = location.pathname.replace('index.html', '')
				if (currentPath === aTagPath) {
					ele.classList.add(a);
				}
			});
		},
		headerHamburger() {
			const $hamburger = document.querySelector( '.js-header-hamburger' );
			const $nav = document.querySelector( '.js-header-nav' );
			const $container = document.querySelector( '.container' );
			let scrollTopNow;

			const fixedOnContainer = () => {
				scrollTopNow = window.scrollY;
				$container.style.position = 'fixed';
				$container.style.width = '100%';
				$container.style.top = -1 * scrollTopNow;
				$container.style.left = 0;
				document.body.classList.add( f );
			};
			const fixedOffContainer = () => {
				$container.style.position = 'static';
				document.body.classList.remove( f );
				window.scrollTo( { top: scrollTopNow } );
			};

			if ( $hamburger ) {
				$hamburger.addEventListener( 'click', ( e ) => {
					e.currentTarget.classList.toggle( a );
					if ( $nav.classList.contains( a ) ) {
						console.log("閉じる");
						$nav.classList.remove( v );
						$nav.classList.remove( a );
						fixedOffContainer();
					} else {
						console.log("開く");
						fixedOnContainer();
						$nav.classList.add( a );
						setTimeout( () => { $nav.classList.add( v ); } );
					}
				} );
			}
		},
		animation() {
			const $fadein = document.querySelectorAll( '.mod-fadein' );
			if ( $fadein.length ) {
				window.addEventListener("scroll", ()=> {
					const screenHeight = window.innerHeight;
					const apperPoint = screenHeight * 0.7;
					$fadein.forEach( ( ele ) => {
						const elementHeightTotop = ele.getBoundingClientRect().top;
						if(elementHeightTotop < apperPoint){
							ele.classList.add( a );
						}
					})
				})
			}
		},
		tabSwitch2() {
			// console.log('tabSwitch2');
			const $tabArea = document.querySelectorAll('.js-tab_area');
			// console.log($tabArea.length);
			if($tabArea.length) {
				$tabArea.forEach( tabArea => {
					const $tab = tabArea.querySelectorAll('.js-tab_item');
					const $content = tabArea.querySelectorAll('.js-tab_content');
					for (let i = 0; i < $tab.length; i++) {
						$tab[i].addEventListener('click', ()=> {
							$tab.forEach( ele => { ele.classList.remove( a ) })
							$content.forEach( ele => { ele.classList.remove( a ) })
							$tab[i].classList.add( a );
							$content[i].classList.add( a );

							const switchElements = document.querySelectorAll( '.js-toggle' );
							switchElements.forEach( switchElement => {
								const toggleBlock = switchElement.nextElementSibling;
								switchElement.classList.remove( a );
								toggleBlock.classList.remove( a );
								toggleBlock.style.height = null;
							} );
						})
					}
				})
			}
		},
		hiddenFooterBar() {
			const $footerLinkItem = document.querySelectorAll('.js-footer_link_item');

			const setBar = (linkItem) => {
				let currentPos = linkItem[0].getBoundingClientRect().top
				for (let i = 1; i < linkItem.length; i++) {
					const nowPos = linkItem[i].getBoundingClientRect().top
					if (currentPos !== nowPos) {
						linkItem[i - 1].classList.add( 'no-bar' );
						currentPos = nowPos;
					}
				}
			}

			if($footerLinkItem.length) {
				setBar($footerLinkItem)
				window.addEventListener('resize' , ()=> {
					$footerLinkItem.forEach( ele => {
						ele.classList.remove( 'no-bar' );
					} )
					setBar($footerLinkItem)
				})
			}
		},
		headerScroll() {
			// スクロール時のヘッダーの色変更
			window.addEventListener("scroll", function () {
				const scroll = window.scrollY;
				const $headerInner = document.querySelector('.header');
				if (scroll > 0) {
					$headerInner.classList.add('is-scroll')
				} else {
					$headerInner.classList.remove('is-scroll')
				}
			});
		},
		scrollToActive() {
			const ele = document.getElementsByClassName('js-scrollToActive');
			const threshold = 0.7
			// console.log(ele);
			window.addEventListener('scroll', () => {
				const windowHeight = window.innerHeight;
				const thresholdPixel = windowHeight * threshold;
				for (let i = 0; i < ele.length; i++) {
					const imageTop = ele[i].getBoundingClientRect().top;
					if (imageTop < thresholdPixel) {
						ele[i].classList.add(a);
					}
				}
			});
		},
		siteSearch() {
			const submit = document.querySelectorAll('.js-siteSearch-submit');
			submit.forEach((submit) => {
				const input = submit.previousElementSibling
				submit.addEventListener('click', () => {
					if(input.value) {
						window.open('https://www.google.co.jp/search?sitesearch=www.tskg-hd.com&q=' + input.value, '_blank', 'location,status,menubar,toolbar,scrollbars,resizable,noopener');
					}else {
						window.open('https://www.google.co.jp/search?sitesearch=www.tskg-hd.com', '_blank', 'location,status,menubar,toolbar,scrollbars,resizable,noopener');
					}
				})
				input.addEventListener('keydown', (e) => {
					if (e.keyCode === 13) {
						if(input.value) {
							window.open('https://www.google.co.jp/search?sitesearch=www.tskg-hd.com&q=' + input.value, '_blank', 'location,status,menubar,toolbar,scrollbars,resizable,noopener');
						}else {
							window.open('https://www.google.co.jp/search?sitesearch=www.tskg-hd.com', '_blank', 'location,status,menubar,toolbar,scrollbars,resizable,noopener');
						}
					}
				})
			})
		},
		openSiteSearch() {
			const header = document.querySelector('.header');
			const openBtn = document.querySelector('.js-search');
			const searchArea = document.querySelector('.js-siteSearchArea');
			const bg = document.querySelector('.js-siteSearchBg')

			openBtn.addEventListener('click', (e) => {
				e.currentTarget.classList.toggle( a );
				header.classList.toggle( 'open-search' );
				searchArea.classList.toggle( a );
			})
			bg.addEventListener('click', (e) => {
				openBtn.classList.remove( a );
				header.classList.remove( 'open-search' );
				searchArea.classList.remove( a );
			})
		},
		share() {
			const sharelist = document.querySelectorAll('.js-share-btn')
            if (sharelist.length) {
                var pageUrl = document.URL;
                var shareUrl = "";
                var sharePagetitle = encodeURIComponent(document.title);
                sharelist.forEach(elem => {
                    if (elem.classList.contains('_facebook')) {
                        // facebook
                        shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + pageUrl;
                        elem.setAttribute('href', shareUrl);
                    }
                    if (elem.classList.contains('_x')) {
                        // X
                        shareUrl = 'https://twitter.com/share?url=' + pageUrl + '&text=' + sharePagetitle;
                        elem.setAttribute('href', shareUrl);
                    }
                    if (elem.classList.contains('_linkedin')) {
                        // Linkedin
                        shareUrl = 'https://www.linkedin.com/sharing/share-offsite/?url=' + pageUrl;
                        elem.setAttribute('href', shareUrl);
                    }
                });
            }
        },
		loadDelayScript() {
			let _this = this;
			_this.nextToggle();
			_this.tabSwitch();
			_this.easeScroll();
			_this.easeScrollHash();
			_this.pageTop();
			_this.setImgAttrWidthHeight();
			_this.setModal();
			_this.inViewAnimation();
			_this.headerCurrent();
			_this.footerCurrent();
			_this.headerHamburger();
			_this.animation();
			_this.tabSwitch2();
			_this.hiddenFooterBar();
			_this.headerScroll();
			_this.scrollToActive();
			_this.siteSearch();
			_this.openSiteSearch();
			_this.share();
			let resizeTime = 0;
			window.addEventListener( 'load', () => {
				_this.matchHeight();
			} );
			window.addEventListener( 'resize', () => {
				clearTimeout( resizeTime );
				resizeTime = setTimeout( () => { _this.matchHeight(); }, 300 );
			} );
		}
	};

	document.addEventListener( 'DOMContentLoaded', () => FUNCTIONS.localDecision() ? FUNCTIONS.localLoading() : FUNCTIONS.loadDelayScript() );
} )();